import React, { FC } from 'react';
import { Modal } from 'react-bootstrap';
import './style/scss/CancelWaitRemoveComplete.index.scss';

interface Props {
  show: boolean;
  onHide: () => void;
}

const CancelWaitRemoveComplete: FC<Props> = ({ show, onHide }) => {
  return (
    <Modal
      show={show}
      onHide={onHide}
      animation
      // className="p-modal-member"
      dialogClassName="p-modal-member__dialog p-modal-member__dialog--width722 p-modal-member__dialog--height-center cancel-wait-remove-complete-mdl"
      contentClassName="p-modal-member__content"
    >
      {/* <Modal.Header closeButton> */}
      {/*  <Modal.Title>Content Class</Modal.Title> */}
      {/* </Modal.Header> */}

      <Modal.Body className="p-modal-member__body">
        <button type="button" className="p-modal-member__close-button" aria-label="閉じる" onClick={onHide} />

        <div className="p-modal-member__container">
          <div className="p-modal-member__header">
            <div className="p-modal-member__title p-modal-member__title--line-height-wide">
              キャンセル待ち予約を
              <br className="u-sp-only" />
              解除しました。
            </div>
          </div>

          <div className="p-modal-member__inner p-modal-member__inner--padding-x80 u-gap15">
            {/* <!--  / 説明文 --> */}
            <div className="c-read u-pb5">
              キャンセル待ち予約の解除が
              <br className="u-sp-only" />
              完了しました。
              <br />
              ご登録のメールアドレス宛に、
              <br />
              キャンセル待ち予約解除のお知らせをお送りしております。
            </div>
          </div>

          {/* <!-- ボタン --> */}
          <div className="p-modal-member__button-area">
            <button
              type="button"
              className="p-modal__cancel-button c-button c-button--secondary c-button--large"
              onClick={onHide}
            >
              ✕ 閉じる
            </button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default CancelWaitRemoveComplete;
